import React from "react";
import {Delete, translate} from "admin-on-rest";
import GiftCardDataList from "./GiftCardDataList";
import GiftCardEditForm from "./GiftCardEditForm";
import GiftCardCreateForm from "./GiftCardCreateForm";

///////////////////// LIST ALL GIFT CARDS /////////////////////
export const GiftCardList = props => <GiftCardDataList {...props} />;

///////////////////// UPDATE GIFT CARD /////////////////////
export const GiftCardEdit = props => <GiftCardEditForm {...props} />;

///////////////////// CREATE NEW GIFT CARD /////////////////////
export const GiftCardCreate = props => <GiftCardCreateForm {...props} />;

///////////////////// DELETE GIFT CARD /////////////////////
const GiftCardDeleteTitleBase = ({record, translate}) => (
  <span>
    {translate("aor.action.delete")}&nbsp;
    {record && <img src={`${record.avatar}?size=25x25`} width="25" alt="" />}
    {record && `${record.name}`}
  </span>
);

const GiftCardTitle = translate(GiftCardDeleteTitleBase);

export const GiftCardDelete = props => (
  <Delete {...props} title={<GiftCardTitle />} />
);



// WEBPACK FOOTER //
// ./src/containers/CRM/GiftCards/index.js